import ApiError from '../api/api-error';

type ErrorContent = string | string[] | Error | null;

export const getMessages = (content: ErrorContent): string[] => {
  if (!content) return [];
  if (Array.isArray(content)) return content;
  if (typeof content === 'string') return [content];
  if (content instanceof ApiError) return content.errors;
  return [content.message];
};
